<template>
  <div
    class="toggle_btn"
    :class="[direction, { collapsed: !value }]"
    @click="$emit('input', !value)"
    :title="value ? '折叠' : '展开'"
  >
    <i class="icon_com comicon_indenttotheleft" />
  </div>
</template>

<script>
export default {
  name: "toggle-btn",
  props: {
    value: Boolean,
    direction: {
      type: String
    }
  }
};
</script>

<style scoped lang="less">
.toggle_btn {
  position: absolute;
  z-index: 1;

  background: rgba(235, 235, 236, 1);
  border-radius: @base-border-radius;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.left,
  &.right {
    width: 15px;
    height: 30px;
    top: 50%;
    transform: translateY(-50%);
  }

  &.left {
    right: -10px;
    i {
      transform: rotate(0deg);
    }
    &.collapsed {
      i {
        transform: rotate(180deg);
      }
    }
  }
  &.right {
    left: -10px;
    i {
      transform: rotate(180deg);
    }
    &.collapsed {
      i {
        transform: rotate(0deg);
      }
    }
  }

  &.bottom,
  &.top {
    width: 30px;
    height: 15px;
    left: 50%;
    transform: translateX(-50%);
  }

  &.top {
    bottom: -10px;
    i {
      transform: rotate(90deg);
    }
    &.collapsed {
      i {
        transform: rotate(-90deg);
      }
    }
  }
  &.bottom {
    top: -10px;
    i {
      transform: rotate(-90deg);
    }
    &.collapsed {
      i {
        transform: rotate(90deg);
      }
    }
  }

  i {
    color: @color-gray-5;
  }
  &:hover {
    background: rgba(237, 242, 248, 1);
    i {
      color: @color-highlight;
    }
  }
}
</style>
